import { Injectable } from '@angular/core';
import { StringUtils } from '../../util/string-utils';
import { Anys } from '../../util/anys';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  public isConfigEqualValue(cle: string, testValue: string): boolean {
    return testValue === configuration.ConfigurationService.getConfig(cle);
  }

  public getValueOrNull(cle: string): string | null {
    const config = configuration.ConfigurationService.getConfig(cle);
    if (StringUtils.isBlank(config)) {
      return null;
    }
    return config;
  }

  public getValueOrBlank(cle: string): string {
    const config = configuration.ConfigurationService.getConfig(cle);
    return !StringUtils.isString(config) ? '' : config;
  }

  public getValueOrDefault(cle: string, defaut: string): string {
    const config = configuration.ConfigurationService.getConfig(cle);
    if (Anys.isNullOrUndef(config) || StringUtils.isBlank(config)) {
      return defaut;
    }
    return config;
  }

  public getValueOrThrow(cle: string): string {
    const config = configuration.ConfigurationService.getConfig(cle);
    if (Anys.isNullOrUndef(config) || StringUtils.isBlank(config)) {
      throw new Error(`Configuration, configuration Absente : ${cle}`);
    }
    return config;
  }

  public getIntegerValueOrDefault(cle: string, defaultValue: number): number {
    const config = configuration.ConfigurationService.getConfig(cle);
    if (Anys.isNullOrUndef(config) || StringUtils.isBlank(config)) {
      return defaultValue;
    }
    const numberConfig = parseInt(config, 10);
    if (!Number.isInteger(numberConfig)) {
      return defaultValue;
    }
    return numberConfig;
  }
}
